import React, { Fragment, useEffect, useState, useRef  } from 'react';
import PropTypes from 'prop-types';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { getPostsFromGroupsFollowing, set_ShowBottomSpinner } from '../actions/postActions';
import { toggleSideNav, setPage, add_To_Recent_History, toggleAuthModal, togglePostModal } from '../actions/navActions';
import { setAlert } from '../actions/alertActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';

// components
import { Button } from '@material-ui/core';
import Post from '../components/Post/Post';

// Logic Only Components
import TriggerAlerts from '../sideEffects/TriggerAlerts/TriggerAlerts';

// Icons
import Spinner from '../components/common/Spinner';

const FollowingPage = ({ 
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    auth, 
    nav: { 
        sideNav,
        website
    },
    post,
    history,
    getPostsFromGroupsFollowing,
    set_ShowBottomSpinner
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if website is custom url or main website
    const [checked_WebsiteType, setChecked_WebsiteType] = useState(false);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // URL and filter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("filter");
    const hostname = window.location.hostname;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    const notFullScreen = windowWidth <= 1170;
    
    useEffect(() => {
        setPage('home');
        add_To_Recent_History(url.pathname);  // current url

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    useEffect(() => {
        setGotPosts(false);
        fetchFollowingPosts();

    }, [auth.user]);

    useEffect(() => {

        renderPostList();

    }, [post.posts, canLoadMore]);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !post.show_bottom_spinner && !post.no_more_posts && post.posts.length > 0 && canLoadMore) {
            loadMore(post.last_page_doc);
        }
    }

    const fetchFollowingPosts = () => {

        if(auth.user) {

            getPostsFromGroupsFollowing(auth.user);
            setGotPosts(true);
        }
    }

    const loadMore = async (lastPage_doc) => {
        if(!auth.user) return;
        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            await getPostsFromGroupsFollowing(auth.user, lastPage_doc)
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }
    }

    const renderPostList = async () => {
        setPostList([]);

        if((post.posts === null && auth.loading) || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(post.posts.length > 0) {
                post.posts.map(post_doc => {
                    const renderPostRecursive = (postComments, parentPost) => {
                        
                        const lastComment = postComments[postComments.length - 1]; // Get the last comment
    
                        return (
                            <Fragment>
                                <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
    
                                {/* Recursive call to render comments of comments */}
                                {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                    <div className="comments-of-comments">
                                    {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                    </div>
                                )}
                            </Fragment>
                        );
    
                    };
    
                    if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                        setPostList(postList => [...postList, (
                            <div className='post_container'>
                                <Post key={post_doc._id} postDoc={post_doc} />
    
                                {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                            </div>
                        )])
                    } else {
                        setPostList(postList => [...postList, (
                            <Post key={post_doc._id} postDoc={post_doc} />
                        )])
                    }
                }) 
            } else {
                setPostList(postList => [...postList, (
                    <div className="no-posts-container">
                        <div className="no-chats">
                            <h1>Nothing to see here - yet</h1>
                            <p>Once you start following groups, more posts will show up here.</p>

                            <Button 
                                onClick={() => window.location = '/groups'}
                                variant="outlined" 
                                className="sidebar__tweet minWidth black"
                            >
                                Discover groups
                            </Button>
                            
                        </div>
                    </div>
                )])
            }
        } 

        setGotPosts(true);
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Following Feed Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    // Check if website is custom url or main website (this page is only for custom URLs)
    if(website && !checked_WebsiteType) {
        window.location.href = '/home';

        setChecked_WebsiteType(true);
    }

    // Check if user is verified. If no redirect to verify page
    if(auth.user && !auth.user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    return (
        <Fragment>
            {/* // -- Trigger Alerts on page load --
            // ----------------------------------
            // after performing an action in another part of the app, user might get redirect to this page.
            // show alerts to user, on their screen, that are pending in localStorage */}

            <TriggerAlerts />

            {/* // -- END: Trigger Alerts on page load -- */}
            
            <Layout handleScroll={handleScroll} sideNav={sideNav} handleSlideMenu={toggleSideNav} page="home">
                
                {auth.loading ? (
                    <Fragment>
                        <Spinner />
                    </Fragment>
                ) : !auth.isAuthenticated ? (
                    <div className="no-posts-container">
                        <div className="no-chats">
                            <h1>Nothing to see here - yet</h1>
                            <p>Once you start following groups, more posts will show up here.</p>

                            <Button 
                                onClick={() => window.location = '/groups'}
                                variant="outlined" 
                                className="sidebar__tweet minWidth black"
                            >
                                Discover groups
                            </Button>
                            
                        </div>
                    </div>
                ) : (
                    <Fragment>

                        <div className="feed_headerTabs">
                            <div onClick={() => window.location = `/home`}>
                                <h3>For You</h3>
                                <div className="block__underline"></div>
                            </div>
                            <div className='active' onClick={() => window.location = `${window.location.pathname}`}>
                                <h3>Following</h3>
                                <div className="block__underline"></div>
                            </div>
                        </div>
                        
                        {/* Render the postList */}
                        {postList}

                        {/* Show a spinner at the bottom if more posts are being loaded */}
                        {(post.show_bottom_spinner && !post.no_more_posts) && <Spinner />}
                        
                        {/* Render a message when there are no more posts to load */}
                        <div className="no-rides">{(post.no_more_posts && post.posts.length !== 0) && "You've reached the end."}</div>

                    </Fragment>
                )}

            </Layout>
        </Fragment>
    )
}

FollowingPage.propTypes = {
    toggleSideNav: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired, // Object prop representing the authentication state of the user
    getPostsFromGroupsFollowing: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    nav: state.nav,
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    toggleAuthModal,
    togglePostModal,
    setAlert,
    getPostsFromGroupsFollowing,
    set_ShowBottomSpinner
})(FollowingPage);
